import { Link } from '@tanstack/react-router'
import type { MouseEventHandler, ReactNode } from 'react'

type Props = {
  href: string
  children?: ReactNode
  className?: string
  prefetch?: boolean
  onClick?: MouseEventHandler<HTMLAnchorElement>
}

export default function NextLink({ href, children, className, onClick }: Props) {
  return (
    <Link to={href} className={className} onClick={onClick}>
      {children}
    </Link>
  )
}
